import * as React from 'react'
import { usePost } from '~/contexts/PostContext'
import { jnstyls, notBlank, imgSize } from '~/utils/helpers'

import * as styles from "~/styles/blog/randoms.module.scss"
import * as bstyle from "~/styles/blog/blog.module.scss"

const possible_png = (url) => {
  return imgSize(url,500)
}

const StoryQuote = ({ blockId, index }) => {
  const { post } = usePost()
  const block = post.data.blocks.find(x => x.id === blockId)
  const { settings } = block

  const qalign = `quote_${settings.align}`

  return (
    <div className={jnstyls([bstyle.sec, styles.quote, styles[qalign]])} block={block.id}>
      {notBlank(settings.image) ? (
        <img className={styles.img} src={possible_png(settings.image)} alt={settings.text} height={200} width={400} />
      ) : (
        <div 
          className={jnstyls([styles.copy, settings.align !== 'left' ? settings[('quote_' + settings.align)] : ''])} 
          dangerouslySetInnerHTML={{ __html: settings.text}} 
        />
      )}
    </div>
  )
}


const StoryStamp = ({ blockId, index }) => {
  const { post } = usePost()
  const block = post.data.blocks.find(x => x.id === blockId)
  const { settings } = block
  
  return (
    <div className={styles.stamp} block={block.id}>
      <img 
        className={styles.img} 
        src={possible_png(settings.image)} 
        alt={settings.text ? settings.text : 'decorative stamp'} 
        height={80} width={100} 
      />
    </div>
  )
}


export { StoryStamp, StoryQuote }


